/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

const STORAGE_KEY = "lan";
const SCNHNELLEINSTIEG_KEY = STORAGE_KEY + ".schnelleinstieg";
const SCNHNELLEINSTIEG_UEBERSPRINGEN_KEY = SCNHNELLEINSTIEG_KEY + ".ueberspringen";

const sessionStorage = {
    schnelleinstieg: {
        get ueberspringen(): number | undefined {
            const item = window.sessionStorage.getItem(SCNHNELLEINSTIEG_UEBERSPRINGEN_KEY);
            if (item) {
                const result = parseInt(item, 10);
                if (!isNaN(result)) {
                    return result;
                }
            }

            return undefined;
        },
        set ueberspringen(jetzt: number | undefined) {
            if (jetzt) {
                window.sessionStorage.setItem(SCNHNELLEINSTIEG_UEBERSPRINGEN_KEY, jetzt.toString());
            } else {
                window.sessionStorage.removeItem(SCNHNELLEINSTIEG_UEBERSPRINGEN_KEY);
            }
        },
    }
}

export default sessionStorage;